"use client";

import styles from "./AuthorizePasswordInput.module.scss";

import {
  setFieldError,
  setFieldValue } from "@/stores";

import { useForm } from "@/hooks";
import {
  Fieldset,
  Input,
} from "@vetty/ui";

/**
 * AuthorizePasswordInput Component
 *
 * Password input field for authorize form with validation and error handling.
 * Manages password field state and clears errors on user input.
 */
export const AuthorizePasswordInput = () => {
  // Get form errors from global state
  const { errors } = useForm();

  /**
   * Handles password input changes
   * Updates field value and clears any existing errors
   */
  const handleInputChange = (field: string, value: string) => {
    setFieldValue(field, value);
    setFieldError(field, "");
  };

  return (
    <Fieldset
      className={styles["comp"]}
      isError={errors.password}
      errorMessage={errors.password}
    >
      <Input
        id={"password"}
        label={"Password"}
        type={"password"}
        onChange={(v) => handleInputChange("password", v)}
      />
    </Fieldset>
  );
};
